import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { constants } from 'common/helpers'
import actions from 'redux/actions'
import { FormattedMessage } from 'sb-react-intl'

import ConfirmModal from 'components/modals/ConfirmModal/ConfirmModal'

import messages from './messages'


export default class NeedUnskipModal extends Component {

  static propTypes = {
    name: PropTypes.string,
    title: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.object,
    ]),
    data: PropTypes.shape({
      isMoveAction: PropTypes.bool,
      onCancel: PropTypes.func,
    }),
  }

  static defaultProps = {
    name: constants.modals.limitedEditionProducts.NeedUnskip,
    title: messages.title,
  }

  handleUnskip = () => {
    this.close()
    actions.models.ui.showRequestLoader()
    // TODO check it works
    actions.models.subscription.unskip('makeup popup')
      .finally(() => {
        actions.models.ui.hideRequestLoader()
      })
      .then(
        () => actions.models.queue.resolveAllPostponedLimitedItems(),
        () => actions.models.queue.removeAllPostponedLimitedItems()
      )
  }

  onCancel = () => {
    const { data: { onCancel, isMoveAction } } = this.props

    if (!isMoveAction) {
      actions.models.queue.resolveAllPostponedLimitedItems({ force: true })
    }

    if (typeof onCancel === 'function') {
      onCancel()
    }

    this.close()
  }

  close = () => {
    const { name } = this.props

    actions.models.modals.close(name)
  }

  render() {
    const { name, title } = this.props

    return (
      <ConfirmModal
        name={name}
        title={title}
        id={name}
        confirmTitle={messages.confirmButton}
        cancelTitle={messages.cancelButton}
        onConfirm={this.handleUnskip}
        onCancel={this.onCancel}
        withTextCancel
      >
        <FormattedMessage {...messages.text} />
      </ConfirmModal>
    )
  }
}
